import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=4af11066"
import script from "./mark.vue?vue&type=script&lang=js"
export * from "./mark.vue?vue&type=script&lang=js"
import style0 from "./mark.vue?vue&type=style&index=0&id=4af11066&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports